import React, { Component } from "react";
import config from "react-global-configuration";
import RequestApi from "../../Miscelania/RequestApi";
import { Link } from "react-router-dom";

// Helpers de formulário
import InputMask from "react-input-mask";
import Select from "react-select";

import { Modal } from "react-bootstrap";

import TrainingStaffDate from "./TrainingStaffDate";
import TrainingStaffObservations from "./TrainingStaffObservations";

class TrainingStaffsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: "",
        type: "",
        status: "closed",
      },
      redirect_url: false,
      loaded: 0,
      training_id: this.props.training_id,
      updated: this.props.updated,
      staffs: [],
      training_certification_staffs: [],
      training_certification_staff_aircraft_models: {},
      modal: false,
      staff_id: false,
      message: "",
      deslocation_type: 1,
    };

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteAll = this.deleteAll.bind(this);
    this.export = this.export.bind(this);
    this.exportCertification = this.exportCertification.bind(this);
    this.confirmPresence = this.confirmPresence.bind(this);
    this.confirmAbsence = this.confirmAbsence.bind(this);
    this.sendHandout = this.sendHandout.bind(this);
    this.sendHandoutAll = this.sendHandoutAll.bind(this);
    this.openAircraftModelModal = this.openAircraftModelModal.bind(this);
    this.forceConfirmPresence = this.forceConfirmPresence.bind(this);
  }

  // Handlers
  handleChange(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeMulti(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if (
      (this.state.loaded === 0 &&
        typeof newProps.training_id !== "undefined" &&
        Array.isArray(newProps.staffs) &&
        newProps.training_certification_staffs !== null) ||
      (this.state.loaded === 1 && newProps.updated === 1)
    ) {
      this.setState({
        training_id: newProps.training_id,
        staffs: newProps.staffs,
        training_certification_staffs: newProps.training_certification_staffs,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert("", "", "open");
    var datasave = {
      staff_id: this.state.staff_id,
      training_id: this.state.training_id,
    };
    var header = this.refs.request_api.header("application/json");
    var self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/treinamento/certificados/colaborador", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          self.props.updateData(responseJson);
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  confirmAbsence(staff_id) {
    var confirm = window.confirm(
      "Tem certeza que gostaria de confirmar a ausência do aluno no treinamento?"
    );
    if (confirm) {
      this.props.handleAlert("", "", "open");
      var datasave = {
        staff_id: staff_id,
        training_id: this.state.training_id,
      };
      var header = this.refs.request_api.header("application/json");
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(config.get("api") + "/treinamento/confirmar/ausencia", {
          method: "PUT",
          mode: "cors",
          headers: value,
          body: JSON.stringify(datasave),
        })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, "alert");
            if (responseJson.status === "success") {
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(
                responseJson.message,
                responseJson.status,
                "open"
              );
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
  }

  confirmPresence(staff_id) {
    var confirm = window.confirm(
      "Tem certeza que gostaria de confirmar a presença do aluno no treinamento?"
    );
    if (confirm) {
      this.props.handleAlert("", "", "open");
      var datasave = {
        staff_id: staff_id,
        training_id: this.state.training_id,
      };
      var header = this.refs.request_api.header("application/json");
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(config.get("api") + "/treinamento/confirmar/presenca", {
          method: "PUT",
          mode: "cors",
          headers: value,
          body: JSON.stringify(datasave),
        })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, "alert");
            if (responseJson.status === "success") {
              self.props.updateData(responseJson);
            } else {
              if (responseJson.data === "deslocation_alert") {
                self.setState({
                  modal_staff: true,
                  message: responseJson.message,
                  staff_id: staff_id,
                  force_change: 0,
                });
                self.props.handleAlert("", "", "closed");
              } else {
                self.props.handleAlert(
                  responseJson.message,
                  responseJson.status,
                  "open"
                );
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
  }

  forceConfirmPresence(event) {
    event.preventDefault();
    var confirm = window.confirm(
      "Tem certeza que gostaria de confirmar a presença do aluno no treinamento?"
    );
    if (confirm) {
      this.props.handleAlert("", "", "open");
      var datasave = {
        staff_id: this.state.staff_id,
        training_id: this.state.training_id,
        deslocation_type: this.state.deslocation_type,
        force_change: 1,
      };
      var header = this.refs.request_api.header("application/json");
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(config.get("api") + "/treinamento/confirmar/presenca", {
          method: "PUT",
          mode: "cors",
          headers: value,
          body: JSON.stringify(datasave),
        })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, "alert");
            if (responseJson.status === "success") {
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(
                responseJson.message,
                responseJson.status,
                "open"
              );
            }
            self.setState({
              modal_staff: false,
              staff_id: false,
              force_change: 0,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
  }

  delete(training_certification_staff_id) {
    var confirm = window.confirm(
      "Tem certeza que gostaria de deletar o aluno dessa aula?"
    );
    if (confirm) {
      this.props.handleAlert("", "", "open");
      var header = this.refs.request_api.header("application/json");
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(
          config.get("api") +
            "/aula/remover/colaborador/" +
            training_certification_staff_id,
          { method: "DELETE", mode: "cors", headers: value }
        )
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, "alert");
            if (responseJson.status === "success") {
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(
                responseJson.message,
                responseJson.status,
                "open"
              );
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
  }

  deleteAll(staff_id) {
    var confirm = window.confirm(
      "Tem certeza que gostaria de deletar o aluno desse treinamento?"
    );
    if (confirm) {
      this.props.handleAlert("", "", "open");
      var header = this.refs.request_api.header("application/json");
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(
          config.get("api") +
            "/treinamento/remover/aluno/" +
            self.state.training_id +
            "/" +
            staff_id,
          { method: "DELETE", mode: "cors", headers: value }
        )
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, "alert");
            if (responseJson.status === "success") {
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(
                responseJson.message,
                responseJson.status,
                "open"
              );
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
  }

  openAircraftModelModal(tcsam) {
    this.setState({
      modal: true,
      training_certification_staff_aircraft_models: tcsam,
    });
  }

  export(event) {
    var self = this;
    var staff_id = event;
    var url = "/treinamento/exportar/comunicado/colaborador/";
    var header = this.refs.request_api.header("application/json");
    self.props.handleAlert("", "", "open");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + url + staff_id + "/" + self.state.training_id, {
        method: "GET",
        mode: "cors",
        headers: value,
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "url");
          if (responseJson.status === "success") {
            self.props.handleAlert("", "", "closed");
            window.open(config.get("cdn") + "/tmp/" + responseJson.data);
          }
        });
    });
  }
  exportCertification(event) {
    var self = this;
    var staff_certification_id = event.currentTarget.value;
    var url = "/exportar/certificado/colaborador/";
    var header = this.refs.request_api.header("application/json");
    self.props.handleAlert("", "", "open");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + url + staff_certification_id, {
        method: "GET",
        mode: "cors",
        headers: value,
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "url");
          if (responseJson.status === "success") {
            self.props.handleAlert("", "", "closed");
            window.open(config.get("cdn") + "/tmp/" + responseJson.data);
          }
        });
    });
  }

  sendHandout(training_id, staff_id) {
    var self = this;
    if (window.confirm("Tem certeza que deseja enviar o comunicado?")) {
      self.props.handleAlert("", "", "open");
      var url = "/treinamento/certificado/aluno/enviar/comunicado/";
      var header = this.refs.request_api.header("application/json");
      Promise.resolve(header).then(function (value) {
        fetch(config.get("api") + url + staff_id + "/" + training_id, {
          method: "PUT",
          mode: "cors",
          headers: value,
        })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, "url");
            if (responseJson.status === "success") {
              self.props.updateData(responseJson);
            }
          });
      });
    }
  }

  sendHandoutAll(training_certification_staff_id) {
    var self = this;
    if (
      window.confirm(
        "Tem certeza que deseja enviar o comunicado de todos os alunos?"
      )
    ) {
      self.props.handleAlert("", "", "open");
      var url = "/treinamento/certificado/aluno/enviar/comunicado/todos/";
      var header = this.refs.request_api.header("application/json");
      Promise.resolve(header).then(function (value) {
        fetch(config.get("api") + url + training_certification_staff_id, {
          method: "PUT",
          mode: "cors",
          headers: value,
        })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, "url");
            if (responseJson.status === "success") {
              self.props.updateData(responseJson);
            }
          });
      });
    }
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={"request_api"} />
        {self.props.status === 1 || self.props.status === 3 ? (
          <div>
            <h3 className="page-title pull-left">Adicionar aluno</h3>
            <div className="clearfix"></div>
            <hr />
            <form onSubmit={this.add}>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Colaborador:</label>
                    <Select
                      className="form-field-name"
                      name="staff_id"
                      value={this.state.staff_id}
                      searchable={true}
                      placeholder={"Selecionar colaborador"}
                      onChange={this.handleSelectChangeMulti.bind(
                        this,
                        "staff_id"
                      )}
                      options={this.state.staffs}
                      multi={true}
                      required
                    />
                  </div>
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-primary btn-lg btn-block"
              >
                <i className="fa fa-fw fa-plus"></i> Adicionar colaborador
              </button>
            </form>
            <hr />
          </div>
        ) : (
          ""
        )}
        <h3 className="page-title pull-left">Lista de alunos</h3>
        <button
          className="btn btn-lg btn-info pull-right"
          onClick={() => {
            self.sendHandoutAll(self.state.training_id);
          }}
        >
          <i className="fa fa-fw fa-envelope"></i> Enviar todos os comunicados
        </button>
        <div className="clearfix"></div>
        <hr />
        {this.state.training_certification_staffs === null ||
        typeof this.state.training_certification_staffs === "undefined" ? (
          <div>
            <small>
              <em>Nenhum aluno cadastrado.</em>
            </small>
            <hr />
          </div>
        ) : (
          <div>
            {Object.keys(self.state.training_certification_staffs).map(
              function (staff) {
                return (
                  <div>
                    <div className="title-staff-trainings">
                      <h5 className="page-title pull-left">
                        {staff}
                        {self.state.training_certification_staffs[staff][0]
                          .handout === 1 ? (
                          <small style={{ color: "green", marginLeft: "15px" }}>
                            <em>Comunicado enviado</em>
                          </small>
                        ) : (
                          ""
                        )}
                      </h5>
                      {self.props.status === 1 || self.props.status === 3 ? (
                        <button
                          className="btn btn-danger pull-right button-inline"
                          onClick={() => {
                            self.deleteAll(
                              self.state.training_certification_staffs[staff][0]
                                .staff_id
                            );
                          }}
                        >
                          <i className="fa fa-fw fa-trash"></i> Remover todos
                        </button>
                      ) : (
                        ""
                      )}
                      {self.props.status === 1 || self.props.status === 2 ? (
                        <div>
                          {self.state.training_certification_staffs[staff][0]
                            .attendance === 0 ? (
                            <button
                              disabled
                              className="btn btn-danger pull-right button-inline"
                            >
                              <i className="fa fa-fw fa-close"></i>
                            </button>
                          ) : (
                            <button
                              className="btn btn-danger pull-right button-inline"
                              onClick={() => {
                                self.confirmAbsence(
                                  self.state.training_certification_staffs[
                                    staff
                                  ][0].staff_id
                                );
                              }}
                            >
                              <i className="fa fa-fw fa-close"></i>
                            </button>
                          )}
                          {self.state.training_certification_staffs[staff][0]
                            .attendance === 1 ? (
                            <button
                              disabled
                              className="btn btn-success pull-right button-inline"
                            >
                              <i className="fa fa-fw fa-check"></i>
                            </button>
                          ) : (
                            <button
                              className="btn btn-success pull-right button-inline"
                              onClick={() => {
                                self.confirmPresence(
                                  self.state.training_certification_staffs[
                                    staff
                                  ][0].staff_id
                                );
                              }}
                            >
                              <i className="fa fa-fw fa-check"></i>
                            </button>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="btn-group pull-right button-inline">
                        <button
                          className="btn btn-info"
                          onClick={() => {
                            self.export(
                              self.state.training_certification_staffs[staff][0]
                                .staff_id
                            );
                          }}
                        >
                          <i className="fa fa-fw fa-file-pdf-o"></i> Comunicado
                        </button>
                        <button
                          className="btn btn-info"
                          onClick={() => {
                            self.sendHandout(
                              self.state.training_id,
                              self.state.training_certification_staffs[staff][0]
                                .staff_id
                            );
                          }}
                        >
                          <i className="fa fa-fw fa-envelope"></i>
                        </button>
                      </div>
                      <div className="clearfix"></div>
                    </div>
                    <table className="table table-staff-trainings">
                      <tbody id="training-certification-staffs">
                        {Object.keys(
                          self.state.training_certification_staffs[staff]
                        ).map(function (k) {
                          return (
                            <tr>
                              <td className="col-md-2">
                                <h5>
                                  <span className="label label-default">
                                    {
                                      self.state.training_certification_staffs[
                                        staff
                                      ][k].certification_name
                                    }
                                  </span>
                                </h5>
                                <h5>
                                  <span className="label label-default">
                                    De{" "}
                                    {
                                      self.state.training_certification_staffs[
                                        staff
                                      ][k].date_start_str
                                    }{" "}
                                    a{" "}
                                    {
                                      self.state.training_certification_staffs[
                                        staff
                                      ][k].date_finish_str
                                    }
                                  </span>
                                </h5>
                              </td>
                              <td className="col-md-4 text-center">
                                <TrainingStaffDate
                                  training_certification_staff_id={
                                    self.state.training_certification_staffs[
                                      staff
                                    ][k].id
                                  }
                                  status={self.props.status}
                                  updated={self.updated}
                                  date_start={
                                    self.state.training_certification_staffs[
                                      staff
                                    ][k].date_start_str
                                  }
                                  date_finish={
                                    self.state.training_certification_staffs[
                                      staff
                                    ][k].date_finish_str
                                  }
                                  updateData={self.props.updateData}
                                  handleAlert={self.props.handleAlert}
                                />
                              </td>
                              <td className="col-md-4 text-center">
                                <TrainingStaffObservations
                                  training_certification_staff_id={
                                    self.state.training_certification_staffs[
                                      staff
                                    ][k].id
                                  }
                                  status={self.props.status}
                                  observations={
                                    self.state.training_certification_staffs[
                                      staff
                                    ][k].observations
                                  }
                                  updateData={self.props.updateData}
                                  handleAlert={self.props.handleAlert}
                                />
                              </td>
                              <td className="text-right col-md-3">
                                <button
                                  className="btn btn-sm btn-success button-inline"
                                  onClick={() =>
                                    self.openAircraftModelModal(
                                      self.state.training_certification_staffs[
                                        staff
                                      ][k]
                                        .training_certification_staff_aircraft_models
                                    )
                                  }
                                >
                                  <i className="fa fa-fw fa-plane"></i>
                                </button>
                                {self.props.status === 1 ||
                                self.props.status === 3 ? (
                                  <button
                                    className="btn btn-sm btn-danger button-inline"
                                    onClick={() =>
                                      self.delete(
                                        self.state
                                          .training_certification_staffs[staff][
                                          k
                                        ].id
                                      )
                                    }
                                  >
                                    <i className="fa fa-fw fa-trash"></i>
                                  </button>
                                ) : (
                                  ""
                                )}
                                {self.state.training_certification_staffs[
                                  staff
                                ][k].finalized === 1 ? (
                                  <button
                                    type="button"
                                    className={"btn btn-sm btn-success"}
                                    onClick={self.exportCertification}
                                    value={
                                      self.state.training_certification_staffs[
                                        staff
                                      ][k].staff_certification_id
                                    }
                                  >
                                    <i className="fa fa-fw fa-file-o"></i>
                                  </button>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                );
              }
            )}
            <hr />
          </div>
        )}

        <Modal
          show={this.state.modal}
          aria-labelledby="contained-modal-title-md"
          bsSize={"medium"}
        >
          <Modal.Header>
            <h4 className="pull-left">Frotas designadas a serem geradas</h4>
            <button
              className="btn btn-danger btn-sm pull-right"
              onClick={() => {
                self.setState({
                  modal: false,
                  training_certification_staff_aircraft_models: {},
                });
              }}
            >
              <i className="fa fa-fw fa-close"></i>
            </button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center">Frota</th>
                  <th className="text-center">Motor</th>
                </tr>
              </thead>
              <tbody id="training-certification-staffs">
                {Object.keys(
                  self.state.training_certification_staff_aircraft_models
                ).map(function (k) {
                  return (
                    <tr>
                      <td className="text-center">
                        {
                          self.state
                            .training_certification_staff_aircraft_models[k]
                            .aircraft_model
                        }
                      </td>
                      <td className="text-center">
                        {
                          self.state
                            .training_certification_staff_aircraft_models[k]
                            .aircraft_model_subtype
                        }
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-danger btn-sm pull-right"
              onClick={() => {
                self.setState({
                  modal: false,
                  training_certification_staff_aircraft_models: {},
                });
              }}
            >
              <i className="fa fa-fw fa-close"></i>
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.modal_staff}
          aria-labelledby="contained-modal-title-md"
          bsSize={"medium"}
        >
          <Modal.Header>
            <h4 className="pull-left">{self.state.message}</h4>
            <button
              className="btn btn-danger btn-sm pull-right"
              onClick={() => {
                self.setState({
                  modal: false,
                  training_certification_staff_aircraft_models: {},
                });
              }}
            >
              <i className="fa fa-fw fa-close"></i>
            </button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <p>
              O colaborador encontra-se de folga e sua residência está em uma
              cidade diferente do treinamento.
            </p>
            <p>O aluno irá por meios próprios?</p>
            <br />
            <form onSubmit={this.forceConfirmPresence}>
              <div className="row">
                <div className="col-md-12 form-group">
                  <Select
                    className="form-field-name"
                    name="deslocation_type"
                    value={this.state.deslocation_type}
                    searchable={true}
                    placeholder={"Selecionar meio de transporte"}
                    onChange={this.handleSelectChange.bind(
                      this,
                      "deslocation_type"
                    )}
                    options={[
                      { value: 1, label: "Sim" },
                      { value: 2, label: "Não" },
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 form-group">
                  <button type={"submit"} className="btn btn-primary btn-block">
                    <i className="fa fa-fw fa-save"></i> Enviar resposta
                  </button>
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-danger btn-sm pull-right"
              onClick={() => {
                self.setState({
                  modal: false,
                  training_certification_staff_aircraft_models: {},
                });
              }}
            >
              <i className="fa fa-fw fa-close"></i>
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default TrainingStaffsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingStaffsTab.js